import { CommonModule, NgFor, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { RouterModule } from "@angular/router";
import { IconArrowForwardComponent } from "@src/app/components/svg/icon-arrow-forward/icon-arrow-forward.component";
import { KebabCasePipe } from "src/app/pipes/kebab-case.pipe";
import { IconArrowBackComponent } from "../../../components/svg/icon-arrow-back/icon-arrow-back.component";
import { SkeletonImageComponent } from "../../skeleton-image/skeleton-image/skeleton-image.component";

@Component({
  selector: "app-next-prev",
  imports: [CommonModule, RouterModule, KebabCasePipe, SkeletonImageComponent, NgFor, NgIf, IconArrowForwardComponent, IconArrowBackComponent],
  templateUrl: "./next-prev.component.html",
  styleUrl: "./next-prev.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/**
 * Componente que muestra los botones de siguiente y anterior noticia.
 */
export class NextPrevComponent {
  @Input({ required: true }) nextprev: any[] = []; // Un objeto que contiene la informacion de la noticia anterior y siguiente.

  trackByNoticia(noticia: any): string {
    return noticia?.idVideo || noticia;
  }
}
